import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ConfigService } from '../../config.service';
import { AESService } from '../../encryption/aes.service';

@Injectable()
export class ListGroupService {

  constructor(public http: HttpClient, public config: ConfigService,private Cryptography : AESService) {
   
  }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.Cryptography.getItem('accesstoken',true) })
  };
  Grouplist(): Observable<any> {
    return this.http.get(this.config.baseURL + '/function/listFunction', this.httpOptions)
      .map((res) => { return res }

      );
  }
  DeleteGroup(user: any): Observable<any> {
    return this.http.delete<any>(this.config.baseURL + `/function/deleteFunction?id=${user}`,this.httpOptions)
      .map((res) => { return res }

      );
  }
  UpdateGroup(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/function/editFunction', user, this.httpOptions)
      .map((res) => { return res }

      );
  }
  getattrbtGroupID(user: any): Observable<any> {
    return this.http.get<any>(this.config.baseURL + `/function/getFunctionDetail?functionId=${user}`, this.httpOptions)
      .map((res) => { return res }

      );
  }
  getattrbtGroupName(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/group/getattribute_forgroup_byname', user, this.httpOptions)
      .map((res) => { return res }

      );
  }
  searchGroup(data: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/function/searchFunction', data, this.httpOptions)
        .map((res) => { return res }

        );
  }
}
